import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import drIsInLogo from "../../assets/dr-is-in.png";
import "./ParentTeacherTipsHome.css";

const PT_PORTAL_ROUTE = "/parent-teacher-portal";
const PT_TIPS_HOME_ROUTE = "/pt/tips";

function clean(v: any) {
  return String(v ?? "").trim();
}

function getPortalReturnPath(location: any): string {
  const fromState = clean(location?.state?.from);
  if (fromState) return fromState;

  const fromStore = clean(sessionStorage.getItem("pt_portal_return"));
  if (fromStore) return fromStore;

  return PT_PORTAL_ROUTE;
}

export default function ParentTeacherTipsHome() {
  const navigate = useNavigate();
  const location = useLocation();

  const portalReturn = useMemo(() => getPortalReturnPath(location), [location]);

  const handleBack = () => {
    navigate(portalReturn || PT_PORTAL_ROUTE, { replace: true });
  };

  const goTips = (cat: "physical" | "mental" | "everyday") => {
    try {
      sessionStorage.setItem("pt_portal_return", portalReturn || PT_PORTAL_ROUTE);
    } catch {}

    navigate(`${PT_TIPS_HOME_ROUTE}/${cat}`, {
      state: { from: portalReturn || PT_PORTAL_ROUTE },
    });
  };

  return (
    <div className="ptTipsHome-page">
      <div className="ptTipsHome-shell">
        <div className="ptTipsHome-top">
          <button className="ptTipsHome-back" type="button" onClick={handleBack}>
            ← Back
          </button>

          <div className="ptTipsHome-brand">
            <img src={drIsInLogo} className="ptTipsHome-logo" alt="Doctor Is In" />
            <div>
              <div className="ptTipsHome-title">Health &amp; Wellness</div>
              <div className="ptTipsHome-sub">
                Helpful wellness tips for parents and teachers.
              </div>
            </div>
          </div>
        </div>

        <div className="ptTipsHome-grid">
          <button className="ptTipsHome-card physical" type="button" onClick={() => goTips("physical")}>
            <div className="ptTipsHome-cardTop">
              <div className="ptTipsHome-icon">💪</div>
              <div className="ptTipsHome-cardText">
                <div className="ptTipsHome-cardTitle">Physical Wellness</div>
                <div className="ptTipsHome-cardSub">Sleep • Hydration • Movement • Nutrition</div>
              </div>
              <div className="ptTipsHome-arrow">›</div>
            </div>
            <div className="ptTipsHome-cardHint">
              Simple habits that help your body feel stronger today.
            </div>
          </button>

          <button className="ptTipsHome-card mental" type="button" onClick={() => goTips("mental")}>
            <div className="ptTipsHome-cardTop">
              <div className="ptTipsHome-icon">🧠</div>
              <div className="ptTipsHome-cardText">
                <div className="ptTipsHome-cardTitle">Mental Health &amp; Stress</div>
                <div className="ptTipsHome-cardSub">Calm • Focus • Anxiety tools • Reset routines</div>
              </div>
              <div className="ptTipsHome-arrow">›</div>
            </div>
            <div className="ptTipsHome-cardHint">
              Quick tools to calm your brain and reset when things feel heavy.
            </div>
          </button>

          <button className="ptTipsHome-card everyday" type="button" onClick={() => goTips("everyday")}>
            <div className="ptTipsHome-cardTop">
              <div className="ptTipsHome-icon">✅</div>
              <div className="ptTipsHome-cardText">
                <div className="ptTipsHome-cardTitle">Everyday Healthy Habits</div>
                <div className="ptTipsHome-cardSub">Time • Routine • Small wins • Consistency</div>
              </div>
              <div className="ptTipsHome-arrow">›</div>
            </div>
            <div className="ptTipsHome-cardHint">
              Small daily decisions that add up fast for adults supporting young people.
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}